import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import AllEventsIcon from "./icons/all-events.svg";
import CoachingSessionIcon from "./icons/coaching-session.svg";
import CommunitySupportIcon from "./icons/community-support.svg";
import DemonstrationAudienceIcon from "./icons/demonstration-audience.svg";
import GroupCoachingIcon from "./icons/group-coaching.svg";
import HostSessionIcon from "./icons/host-session.svg";
import OnDemandPracticeIcon from "./icons/on-demand-practice.svg";
import OutreachClientIcon from "./icons/outreach-client.svg";
import PaidReadingIcon from "./icons/paid-reading.svg";
import PracticeCirclesIcon from "./icons/practice-circles.svg";
import PracticeDemonstrationIcon from "./icons/practice-demonstration.svg";
import ProfessionalDemonstrationIcon from "./icons/professional-demonstration.svg";
import ScheduledPracticeIcon from "./icons/scheduled-practice.svg";
import SpeakerEventsIcon from "./icons/speaker-events.svg";
import StarterClientIcon from "./icons/starter-client.svg";
import TechnologySupportIcon from "./icons/technology-support.svg";
import "./serviceentry.css";

const coaching30MinuteSession =
  process.env.REACT_APP_COACHING_30_Minute_Session || 64;
// "Support Sessions" subsession id - live: 89, staging: 86 (same name both places)
const supportSessionId = process.env.REACT_APP_SUPPORT_SESSION_ID || 86;

const serviceColumns = [
  {
    title: "Practice",
    items: [
      {
        label: "1 on 1 Practices",
        splitTile: true,
        icon: ScheduledPracticeIcon,
        iconAlt: "",
      },
      {
        label: "1 on 1 On Demand",
        to: "/go-on-demand-practice?to=ondemand",
        icon: OnDemandPracticeIcon,
        iconAlt: "",
      },
      {
        label: "Practice Circles",
        to: "/go-on-demand-practice?to=allpracticecircles",
        groupEvent: true,
        icon: PracticeCirclesIcon,
        iconAlt: "",
      },
      {
        label: "Practice Demos",
        to: "/go-on-demand-practice?to=platformDemonstration",
        groupEvent: true,
        icon: PracticeDemonstrationIcon,
        iconAlt: "",
      },
    ],
  },
  {
    title: "Serve",
    items: [
      {
        label: "Host Any",
        to: "/availability",
        icon: HostSessionIcon,
        iconAlt: "",
      },
      {
        label: "Pro Demos",
        to: "/go-on-demand-practice?to=professionalDemonstrations",
        groupEvent: true,
        icon: ProfessionalDemonstrationIcon,
        iconAlt: "",
      },
      {
        label: "Starter On Demand",
        disabled: true,
        icon: StarterClientIcon,
        iconAlt: "",
      },
      {
        label: "Outreach On Demand",
        to: "/go-on-demand-client",
        icon: OutreachClientIcon,
        iconAlt: "",
      },
    ],
  },
  {
    title: "Strengthen",
    items: [
      {
        label: "1 on 1 Coaching",
        coachingTile: true,
        icon: CoachingSessionIcon,
        iconAlt: "",
      },
      {
        label: "Group Coaching",
        to: "/go-on-demand-practice?to=groupcoaching",
        groupEvent: true,
        icon: GroupCoachingIcon,
        iconAlt: "",
      },
      {
        label: "Community Support Groups",
        to: "/go-on-demand-practice?to=communitysupportgroups",
        groupEvent: true,
        icon: CommunitySupportIcon,
        iconAlt: "",
        smallLabel: true,
      },
      {
        label: "Paid Pro Reading",
        to: "/booking?to=professionalsessions&auto_open_professional=true&calendar=true",
        onClick: () => {
          localStorage.removeItem("bookingFrom");
        },
        icon: PaidReadingIcon,
        iconAlt: "",
      },
    ],
  },
  {
    title: "Observe",
    items: [
      {
        label: "Speaker Events",
        speakerTile: true,
        groupEvent: true,
        icon: SpeakerEventsIcon,
        iconAlt: "",
      },
      {
        label: "Practice Dem Audience",
        to: "/go-on-demand-practice?to=platformDemonstration",
        groupEvent: true,
        icon: DemonstrationAudienceIcon,
        iconAlt: "",
        smallLabel: true,
      },
      {
        label: "Pro Dem Audience",
        to: "/go-on-demand-practice?to=professionalDemonstrations",
        groupEvent: true,
        icon: ProfessionalDemonstrationIcon,
        iconAlt: "",
      },
      {
        label: "Tech Support",
        to: `/booking?to=supportteam&session_length=${supportSessionId}&calendar=true`,
        icon: TechnologySupportIcon,
        iconAlt: "",
      },
    ],
  },
];

function PracticeSessionTile({ item }) {
  const [showPopup, setShowPopup] = useState(false);
  const [selectedDuration, setSelectedDuration] = useState("");
  const navigate = useNavigate();

  const durationOptions = [
    { label: "Practice - 30 Min (15 Min each)", path: "/booking?to=bookwithother&session_length=62&calendar=true" },
    { label: "Practice - 60 Min (30 Min each)", path: "/booking?to=bookwithother&session_length=26&calendar=true" },
  ];

  const handleGo = () => {
    if (!selectedDuration) return;
    setShowPopup(false);
    setSelectedDuration("");
    localStorage.setItem("coachListBackUrl", selectedDuration);
    navigate(selectedDuration);
  };

  return (
    <>
      {showPopup && (
        <div className="split-tile-popup-overlay" onClick={() => { setShowPopup(false); setSelectedDuration(""); }}>
          <div className="split-tile-popup" onClick={(e) => e.stopPropagation()}>
            <button className="split-tile-popup-close" onClick={() => { setShowPopup(false); setSelectedDuration(""); }}>✕</button>
            <p className="split-tile-popup-title">Choose a session duration:</p>
            <select
              className="split-tile-popup-select"
              value={selectedDuration}
              onChange={(e) => setSelectedDuration(e.target.value)}
            >
              <option value="">Select Session Length/Type</option>
              {durationOptions.map((opt) => (
                <option key={opt.path} value={opt.path}>{opt.label}</option>
              ))}
            </select>
            <button
              className="split-tile-popup-go"
              disabled={!selectedDuration}
              onClick={handleGo}
            >
              Go To Full Calendar View
            </button>
          </div>
        </div>
      )}

      <div className="service-entry-tile service-entry-tile--split">
        <div className="split-tile-header" onClick={() => setShowPopup(true)}>
          {item.icon && (
            <span className="service-entry-card-icon">
              <img src={item.icon} alt={item.iconAlt} />
            </span>
          )}
          <span className="service-entry-card-title">{item.label}</span>
        </div>
        <div className="split-tile-options">
          <Link className="split-tile-option" to="/booking?to=bookwithother&session_length=62&calendar=true">
            30 Min
          </Link>
          <Link className="split-tile-option" to="/booking?to=bookwithother&session_length=26&calendar=true">
            60 Min
          </Link>
        </div>
      </div>
    </>
  );
}

const coaching60MinuteSession = 92;

function CoachingSessionTile({ item }) {
  const [showPopup, setShowPopup] = useState(false);
  const [selectedDuration, setSelectedDuration] = useState("");
  const navigate = useNavigate();

  const durationOptions = [
    { label: "Coaching 30 Minute Session", path: `/booking?to=coaching1on1&session_length=${coaching30MinuteSession}&calendar=true` },
    { label: "Coaching 60 Minute Session", path: `/booking?to=coaching1on1&session_length=${coaching60MinuteSession}&calendar=true` },
  ];

  const handleGo = () => {
    if (!selectedDuration) return;
    setShowPopup(false);
    setSelectedDuration("");
    localStorage.setItem("coachListBackUrl", selectedDuration);
    navigate(selectedDuration);
  };

  return (
    <>
      {showPopup && (
        <div className="split-tile-popup-overlay" onClick={() => { setShowPopup(false); setSelectedDuration(""); }}>
          <div className="split-tile-popup" onClick={(e) => e.stopPropagation()}>
            <button className="split-tile-popup-close" onClick={() => { setShowPopup(false); setSelectedDuration(""); }}>✕</button>
            <p className="split-tile-popup-title">Choose a session duration:</p>
            <select
              className="split-tile-popup-select"
              value={selectedDuration}
              onChange={(e) => setSelectedDuration(e.target.value)}
            >
              <option value="">Select Session Length/Type</option>
              {durationOptions.map((opt) => (
                <option key={opt.path} value={opt.path}>{opt.label}</option>
              ))}
            </select>
            <button
              className="split-tile-popup-go"
              disabled={!selectedDuration}
              onClick={handleGo}
            >
              Go To Full Calendar View
            </button>
          </div>
        </div>
      )}

      <div className="service-entry-tile service-entry-tile--split">
        <div className="split-tile-header" onClick={() => setShowPopup(true)}>
          {item.icon && (
            <span className="service-entry-card-icon">
              <img src={item.icon} alt={item.iconAlt} />
            </span>
          )}
          <span className="service-entry-card-title">{item.label}</span>
        </div>
        <div className="split-tile-options">
          <Link
            className="split-tile-option"
            to={`/booking?to=coaching1on1&session_length=${coaching30MinuteSession}&calendar=true`}
            onClick={() => localStorage.setItem("coachListBackUrl", `/booking?to=coaching1on1&session_length=${coaching30MinuteSession}&calendar=true`)}
          >
            30 Min
          </Link>
          <Link
            className="split-tile-option"
            to={`/booking?to=coaching1on1&session_length=${coaching60MinuteSession}&calendar=true`}
            onClick={() => localStorage.setItem("coachListBackUrl", `/booking?to=coaching1on1&session_length=${coaching60MinuteSession}&calendar=true`)}
          >
            60 Min
          </Link>
        </div>
      </div>
    </>
  );
}

function SpeakerEventsTile({ item }) {
  const [showPopup, setShowPopup] = useState(false);
  const navigate = useNavigate();

  return (
    <>
      {showPopup && (
        <div className="split-tile-popup-overlay" onClick={() => setShowPopup(false)}>
          <div className="split-tile-popup" onClick={(e) => e.stopPropagation()}>
            <button className="split-tile-popup-close" onClick={() => setShowPopup(false)}>✕</button>
            <p className="split-tile-popup-title">Would you like to see Upcoming or Past Events?</p>
            <div className="split-tile-popup-actions">
              <button
                className="split-tile-popup-go"
                onClick={() => { setShowPopup(false); navigate("/go-on-demand-practice?to=speakerEvents"); }}
              >
                Upcoming
              </button>
              <button
                className="split-tile-popup-go split-tile-popup-go--outline"
                onClick={() => { setShowPopup(false); navigate("/go-on-demand-practice?to=speakerEventsPast"); }}
              >
                Past
              </button>
            </div>
          </div>
        </div>
      )}

      <div className="service-entry-tile service-entry-tile--split">
        {item.groupEvent && <span className="service-entry-card-tag">Group</span>}
        <div className="split-tile-header" onClick={() => setShowPopup(true)}>
          {item.icon && (
            <span className="service-entry-card-icon">
              <img src={item.icon} alt={item.iconAlt} />
            </span>
          )}
          <span className="service-entry-card-title">{item.label}</span>
        </div>
        <div className="split-tile-options">
          <Link className="split-tile-option" to="/go-on-demand-practice?to=speakerEvents">
            Upcoming
          </Link>
          <Link className="split-tile-option" to="/go-on-demand-practice?to=speakerEventsPast">
            Past
          </Link>
        </div>
      </div>
    </>
  );
}

function ServiceTile({ item }) {
  if (item.splitTile) return <PracticeSessionTile item={item} />;
  if (item.coachingTile) return <CoachingSessionTile item={item} />;
  if (item.speakerTile) return <SpeakerEventsTile item={item} />;
  const tag = item.groupEvent ? "Group" : item.tag;
  const content = (
    <>
      {tag && <span className="service-entry-card-tag">{tag}</span>}
      {item.icon && (
        <span className="service-entry-card-icon">
          <img src={item.icon} alt={item.iconAlt} />
        </span>
      )}
      <span className="service-entry-card-title">{item.label}</span>
    </>
  );

  const tileClassName = [
    "service-entry-tile",
    tag ? "service-entry-tile--tagged" : "",
    item.disabled ? "service-entry-tile--disabled" : "",
    item.smallLabel ? "service-entry-tile--small" : "",
  ]
    .filter(Boolean)
    .join(" ");

  if (item.disabled || !item.to) {
    return (
      <div className={tileClassName} aria-disabled="true">
        {content}
      </div>
    );
  }

  return (
    <Link className={tileClassName} to={item.to} onClick={item.onClick}>
      {content}
    </Link>
  );
}

export default function MediumServiceEntry() {
  const { current_mediumship_level } = useSelector((state) => state.user.user);
  const canAccessClientOnDemand =
    current_mediumship_level == 3 ||
    current_mediumship_level == 5 ||
    current_mediumship_level == 6 ||
    current_mediumship_level == 7;

  return (
    <div className="service-entry-shell">
      <div className="service-entry-intro">
        <h1>Choose the next step in your journey</h1>
      </div>

      <div className="service-entry-board">
        <div className="service-entry-columns">
          {serviceColumns.map((column) => (
            <section className="service-entry-column" key={column.title}>
              <h2>{column.title}</h2>
              <div className="service-entry-list">
                {column.items.map((item) => {
                  const resolved =
                    item.label === "Outreach On Demand" && !canAccessClientOnDemand
                      ? { ...item, disabled: true, to: undefined }
                      : item;
                  return <ServiceTile item={resolved} key={item.label} />;
                })}
              </div>
            </section>
          ))}
        </div>

        <Link className="service-entry-all-events" to="/go-on-demand-practice?to=platforGroupAll">
          <span className="service-entry-card-icon service-entry-card-icon--all">
            <img src={AllEventsIcon} alt="" />
          </span>
          <span>All Above Group Events</span>
        </Link>
      </div>
    </div>
  );
}
